module.exports = __webpack_public_path__ + "img/icon-menu-chat.9ebff0b6.svg";